// extracted by mini-css-extract-plugin
module.exports = {"banner":"_025a50318d--banner--1OFLR","banner-image":"_025a50318d--banner-image--2CeqR"};